import React, { useState, useRef, useEffect, useCallback } from "react";
import LazyImage from "./LazyImage";
import LoadingSquare from "../../Common/LoadingSquare";
import ImageCellOverlay from "./ImageCellOverlay";
import ImageCellSVbutton from "./ImageCellSVbutton";
import ImageCellViewButton from "./ImageCellViewButton";
import ImageCellDead from "./ImageCellDead";
import { useDeviceDetection } from "../../../hooks/useDeviceDetection";
//import "./ImageGrid.css";
import "./ImageCell.css";

const ImageCell = ({ img, index, onOpenStreetView, onOpenFull }) => {
  const { isTouch } = useDeviceDetection();
  const containerRef = useRef(null);

  const [active, setActive] = useState(isTouch);
  const [expanded, setExpanded] = useState(false);

  const [imageLoaded, setImageLoaded] = useState(false);

  const def = isTouch ? "thumbs" : "medium";

  const handleMouseEnter = useCallback(() => {
    if (!isTouch) setActive(true);
  }, [isTouch]);

  const handleMouseLeave = useCallback(() => {
    if (!isTouch) {
      setActive(false);
      setExpanded(false);
    }
  }, [isTouch]);

  const toggleExpand = useCallback((evt) => {
    evt.stopPropagation();
    setExpanded((v) => !v);
  }, []);

  const gotoSV = useCallback(
    (evt) => {
      evt.stopPropagation();
      if (!img.hasCoords) return;

      onOpenStreetView?.({
        coords: img.coords,
        id: img.id,
        nyme: img.nyme,
        adress: img.adress,
        bgColor: img.bgColor,
        typoloColor: img.typoloColor,
        heading: 0,
        pitch: 0,
        zoom: 1,
      });
    },
    [img, onOpenStreetView]
  );

  useEffect(() => {
    if (!expanded) return;

    const handleClickOutside = (e) => {
      if (!containerRef.current?.contains(e.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside, {
      passive: true,
    });

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, [expanded]);

  return (
    <div
      ref={containerRef}
      className={`grid-cell ${isTouch ? "touch" : ""} ${
        active ? "active" : ""
      }`}
      style={{
        backgroundColor: imageLoaded ? img.color : img.color,
      }}
      //onClick={(e) => onOpenFull?.(img)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <LoadingSquare color={img.typoloColor} isLoaded={imageLoaded} />

      <LazyImage
        src={`${process.env.PUBLIC_URL}/images_compress/${def}/${img.id}`}
        alt={img.nyme}
        hovered={active}
        containerRef={containerRef}
        onLoad={() => setImageLoaded(true)}
      />
      {/* 🔵 animation tant que l'image charge */}
      {/*!imageLoaded && (
        <LoadingSquare color={img.color //|| img.typoloColor/>/} />
      )*/}

      <ImageCellOverlay img={img} expanded={expanded} onClick={toggleExpand} />

      <ImageCellViewButton onClick={() => onOpenFull?.(img)} bgColor={img.typoloColor} />

      {img.hasCoords && (
        <ImageCellSVbutton onClick={gotoSV} bgColor={img.typoloColor} />
      )}


      {img.statut  && <ImageCellDead bgColor={img.typoloColor} statut={img.statut} />}
    </div>
  );
};

export default ImageCell;


;